import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import SideMenu from "../../features/sideMenu/SideMenu";
import ButtonStyledSelect from "../../ui/select/selection";
import Map from "../../ui/map/Map";
import PointerMap from "../../assets/img/svg/providers/markerProveedorActivo.svg";
import PointerMapDisable from "../../assets/img/svg/providers/markerProveedorInactivo.svg";
import PointerMapProcess from "../../assets/img/svg/providers/markerProveedorEnProceso.svg";
import countActivo from "../../assets/img/svg/providers/countActivo.svg";
import countExpirado from "../../assets/img/svg/providers/countExpirado.svg";
import countEnProceso from "../../assets/img/svg/providers/countEnProceso.svg";
import { itemsProviders } from "../../constants/providers";
import "./MapProviders.responsive.css";

const normalize = (str = "") =>
  str
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim();

const canonizarEstatus = (estatus) => {
  const s = normalize(estatus || "inactivo");
  if (["periodo de prueba", "no deseado"].includes(s)) return "inactivo";
  if (s.includes("proceso")) return "proceso de integración";
  if (s.includes("inactivo")) return "inactivo";
  if (s.includes("activo")) return "activo";
  return "inactivo";
};

const getIconUrlByCanonical = (canon) => {
  switch (canon) {
    case "activo":
      return PointerMap;
    case "proceso de integración":
      return PointerMapProcess;
    default:
      return PointerMapDisable;
  }
};
const MapProviders = ({ API_URL }) => {
  const [allData, setAllData] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const status = [
    { value: "activo", label: "Activo" },
    { value: "proceso de integración", label: "En proceso" },
    { value: "inactivo", label: "Inactivo" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.post(
        `${API_URL}/api/empresas-por-criterios`,
        {
          razonSocial: null,
          rfc: null,
          cobertura: null,
          coberturaForanea: null,
          numbreContacto: null,
          especialidad: null,
          numGafete: null,
          estatusEmpresa: null,
          buscarInhabilitadas: false,
        },
        { withCredentials: true }
      );

      const data = (response.data || []).map((e) => ({
        ...e,
        _estatusCanon: canonizarEstatus(e?.estatusEmpresa?.nombre),
      }));

      setAllData(data);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [API_URL]);

  const counts = useMemo(() => {
    const acc = { activo: 0, proceso: 0, inactivo: 0 };
    for (const e of allData) {
      if (e._estatusCanon === "activo") acc.activo++;
      else if (e._estatusCanon === "proceso de integración") acc.proceso++;
      else acc.inactivo++;
    }
    return acc;
  }, [allData]);

  useEffect(() => {
    const selected = (selectedStatus || []).map((v) => normalize(v));
    const filtered = selected.length
      ? allData.filter((e) => selected.includes(normalize(e._estatusCanon)))
      : allData;

    const mapped = filtered.map((item) => ({
      lat: item.latitude,
      lng: item.longitude,
      icon: getIconUrlByCanonical(item._estatusCanon),
      info: {
        razonSocial: item.razonSocial || "Sin razón social",
        direccion: item.direccionFiscal || "Sin dirección",
        status: item._estatusCanon,
      },
    }));

    setMarkers(mapped);
  }, [selectedStatus, allData]);

  return (
    <div className="mp-container" style={{ display: "flex", width: "100%" }}>
      {/* Sidebar */}
      <div className="mp-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>

      {/* Contenido */}
      <div
        className="mp-main"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
        }}
      >
        <h1 className="map-title">Mapa de proveedores</h1>

        {/* Controles */}
        <div
          className="mp-controls"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0rem",
            marginBottom: "1rem",
          }}
        >
          {/* Select */}
          <div className="mp-selectWrap" style={{ width: "auto" }}>
            <ButtonStyledSelect
              options={status}
              value={status.filter((s) => selectedStatus.includes(s.value))}
              onChange={(opts) =>
                setSelectedStatus((opts || []).map((o) => o.value))
              }
              placeholder="Filtrar por estatus"
              isMulti
            />
          </div>

          {/* Conteos */}
          <div className="mp-counters">
            <div className="map-status-status d-flex">
              <img src={countActivo} alt="Activo" />
              <div className="map-status-status-text">
                <p className="status-label">Activos</p>
                <p className="status-value">{counts.activo}</p>
              </div>
            </div>

            <div className="map-status-status d-flex">
              <img src={countEnProceso} alt="En proceso" />
              <div className="map-status-status-text">
                <p className="status-label">En proceso</p>
                <p className="status-value">{counts.proceso}</p>
              </div>
            </div>

            <div className="map-status-status d-flex">
              <img src={countExpirado} alt="Inactivo" />
              <div className="map-status-status-text">
                <p className="status-label">Inactivos</p>
                <p className="status-value">{counts.inactivo}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Mapa */}
        <div className="mp-mapWrap">
          <Map markers={markers} zoom={7} />
        </div>
      </div>
    </div>
  );
};

export default MapProviders;
